export const HIDE_DECLARATION_MODAL = "HIDE_DECLARATION_MODAL";
export const hideDeclarationModal = () => ({ type: HIDE_DECLARATION_MODAL });

export const SHOW_DECLARATION_MODAL = "SHOW_DECLARATION_MODAL";
export const showDeclarationModal = () => ({ type: SHOW_DECLARATION_MODAL });
